import {useHistory} from 'react-router-dom';
import {Button} from "react-bootstrap";


const LinkButton = (props) => {
    const history = useHistory();
    const handleClick = () => {
        if (props.route === '/Project' && props.component !== undefined) {
            history.push({pathname: props.route, search: `?type=${props.project}&id=${props.component}`});
            return;
        }
        history.push({pathname: props.route});
    };

    return (
        <Button onClick = {handleClick}>{props.name}</Button>
    );
}

export default LinkButton;
